import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Clock } from "lucide-react";
import { ARTICLES } from "../../lib/articles";

export default function LearnHub() {
  return (
    <section
      id="learn"
      className="py-20 md:py-32 border-t border-slate-200 bg-white"
      data-testid="learn-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
              <BookOpen className="w-3.5 h-3.5 text-[#C9A349]" /> Free guides · Plain English
            </div>
            <h2 className="mt-4 font-heading font-black text-4xl md:text-5xl tracking-tight leading-[1.05]">
              Tax stuff,
              <br />
              <span className="text-[#C9A349]">explained like a human.</span>
            </h2>
            <p className="mt-5 text-slate-600 text-lg max-w-xl">
              No jargon. No 80-page PDFs. Short reads our clients send to their tradies, mates,
              and partners — designed to make NZ tax less confusing for everyone.
            </p>
          </div>
          <div className="text-xs text-slate-500 max-w-xs leading-relaxed">
            <strong className="text-slate-700">Found this helpful?</strong> Hit share on the
            article — every one has its own link, so it works in Facebook posts, emails, and
            Messenger DMs.
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {ARTICLES.map((a) => (
            <ArticleCard key={a.slug} article={a} />
          ))}
        </div>
      </div>
    </section>
  );
}

function ArticleCard({ article }) {
  return (
    <Link
      to={`/learn/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group relative flex flex-col border border-slate-200 bg-white hover:border-[#0A192F] transition-colors p-7 md:p-8"
    >
      <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-[#C9A349]">
        {article.category}
      </div>
      <h3 className="mt-3 font-heading font-black text-xl md:text-2xl tracking-tight leading-tight text-[#0A192F] group-hover:text-[#0A192F]">
        {article.title}
      </h3>
      <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">{article.description}</p>
      <div className="mt-6 flex items-center justify-between border-t border-slate-200 pt-4">
        <span className="inline-flex items-center gap-1.5 text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500">
          <Clock className="w-3.5 h-3.5" /> {article.readMinutes} min read
        </span>
        <span className="inline-flex items-center gap-2 text-xs font-heading font-bold uppercase tracking-[0.15em] text-[#0A192F] group-hover:text-[#C9A349] transition-colors">
          Read guide <ArrowRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}

function ComingSoonCard({ kicker, title }) {
  return (
    <div
      className="relative flex flex-col border border-dashed border-slate-300 p-7 md:p-8 bg-slate-50/60"
      data-testid="article-card-coming-soon"
    >
      <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-400">
        {kicker}
      </div>
      <h3 className="mt-3 font-heading font-black text-xl md:text-2xl tracking-tight leading-tight text-slate-400">
        {title}
      </h3>
      <p className="mt-3 text-sm text-slate-400 leading-relaxed flex-1">
        New guides drop monthly. Want it sooner? Hit "Email us" and tell us what to write.
      </p>
    </div>
  );
}
